if (!customElements.get("m-collection-list")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.items = this.dataset.items),
        (this.total = this.dataset.total),
        (this.autoplay = "true" === this.dataset.autoplay),
        (this.autoplaySpeed = this.dataset.autoplaySpeed),
        (this.paginationType = this.dataset.paginationType),
        (this.expanded = "true" === this.dataset.expanded),
        (this.mobileDisableSlider =
          "true" === this.dataset.mobileDisableSlider),
        this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        });
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      );
      MinimogTheme.config.mqlMobile && this.mobileDisableSlider
        ? (t?.classList.add("m:hidden"),
          e.classList.remove("swiper-container"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t?.classList.remove("m:hidden"), this.initSlider());
    }
initSlider() {
  const { slideContainer: e } = queryDomNodes(this.selectors, this);
  e?.classList.add("swiper-container");
  
  this.slider = new MinimogLibs.Swiper(e, {
    // Global defaults
    loop: false,
    slidesPerView: 3.25,
    slidesPerGroup: 1,
  centeredSlides: false,
  centeredSlidesBounds: true,
  centerInsufficientSlides: false,     // especially helpful when fewer slides exist
  watchOverflow: true,                // avoid extra spacing if slides < slidesPerView
  slidesOffsetBefore: 0,             // you can bump this up if you want more left padding
  slidesOffsetAfter: 200,              // or increase if you want more right padding
    autoplay: this.autoplay && {
      delay: 1000 * parseInt(this.autoplaySpeed),
    },

    // Adjust at different breakpoints
    breakpoints: {
      // At <480px, it will use the global 2.25 (or you can put 2.25 here too).
      480: {
        slidesPerView: 5.5
      },
      768: {
        slidesPerView: 5.5
      },
      1280: {
        slidesPerView: 7.5,
      }
    },

    pagination:
      this.paginationType === "fraction"
        ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: false,
            type: "fraction",
          }
        : {
            el: this.querySelector(".swiper-pagination"),
            clickable: false,
            bulletClass: "m-dot",
            bulletActiveClass: "m-dot--active",
            renderBullet: function (index, className) {
              return (
                `<span class="${className}">
                  <svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                    <circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle>
                  </svg>
                </span>`
              );
            },
          },

    on: {
      init() {
        // Small hack to fix Swiper dimension calculations on init
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 100);
      },
    },
  });

  // Navigation buttons
  const t = this.querySelector(".m-slider-controls"),
    i = t && t.querySelector(".m-slider-controls__button-prev"),
    s = t && t.querySelector(".m-slider-controls__button-next");
  if (this.slider && i && s) {
    i.addEventListener("click", () => this.slider.slidePrev());
    s.addEventListener("click", () => this.slider.slideNext());
  }

  this.swiper = e?.swiper;
}
  }
  customElements.define("m-collection-list", e);
}
